'use client'

import { EngineIndicator } from '@/components/dashboard/engine-indicator'
import type { Engine } from '@/lib/ai/constants'
import type { PromptEngineStatus } from '@/lib/runs/helpers'
import type { SandboxVisibilityStatus } from '../data/types'

const STATUS_MAP: Record<SandboxVisibilityStatus, PromptEngineStatus> = {
  visible: 'mentioned_cited',
  partial: 'mentioned_only',
  'not-visible': 'not_mentioned',
}

interface SandboxEngineIndicatorProps {
  engine: Engine
  status: SandboxVisibilityStatus
}

export function SandboxEngineIndicator({ engine, status }: SandboxEngineIndicatorProps) {
  return <EngineIndicator engine={engine} status={STATUS_MAP[status]} />
}
